import React from 'react';
import { Route, Redirect, Router, Switch } from 'react-router-dom';
import { Main } from './main/Screen';
import { SignInScreen } from './auth/Screen/SignIn';
import { ForgotScreen } from './auth/Screen/ForgotPassword';
import { SetNewScreen } from './auth/Screen/SetNewPassword';
import { ResetScreen } from './auth/Screen/ResetPassword'
import { PUBLIC_ROUTE } from './route.constants';
import { useSelector } from 'react-redux';
import { authStateSelector, AUTH_STATE_KEY } from './auth/auth-reducer'
import { generalStateSelector, GENERAL_STATE_KEY } from './redux/general/general-reducer'
import { AppIdleTimer } from './auth/Screen/IdleTimer';
import { createBrowserHistory } from 'history';
import { ConfirmEmailScreen } from './main/Screen/Report/ConfirmEmail';
import { getLocalStorage } from "./shared/helpers/utility";
import { AUTH_LOCAL_STORAGE_KEY } from "./auth/auth-constant";

export const history = createBrowserHistory();

const publicRoutes = [
  {
    path: PUBLIC_ROUTE.LANDING,
    exact: true,
    component: SignInScreen,
  },
  {
    path: PUBLIC_ROUTE.SIGN_IN,
    component: SignInScreen,
  },
  {
    path: PUBLIC_ROUTE.RESET_PASSWORD,
    component: ResetScreen,
  },
  {
    path: PUBLIC_ROUTE.FORGOT_PASSWORD,
    component: ForgotScreen,
  },
  {
    path: PUBLIC_ROUTE.SET_NEW_PASSWORD,
    component: SetNewScreen,
  },
  {
    path: PUBLIC_ROUTE.CONFIRM_EMAIL,
    component: ConfirmEmailScreen
  }
];
function PrivateRoute({ children, ...rest }) {
  const isLoggedIn = useSelector(authStateSelector(AUTH_STATE_KEY.ID_TOKEN));

  return (
    <Route
      {...rest}
      render={({ location }) =>
        isLoggedIn ? (
          children
        ) : (
            <Redirect
              to={{
                pathname: '/signin',
                state: { from: location },
              }}
            />
          )
      }
    />
  );
}
export default function Routes() {
  const localIsLogin = getLocalStorage(AUTH_LOCAL_STORAGE_KEY.TOKEN_ID);
  const isMaintenance = useSelector(generalStateSelector(GENERAL_STATE_KEY.IS_MAINTENANCE));
  const checkBrowserNotSupport = useSelector(generalStateSelector(GENERAL_STATE_KEY.CHECK_BROWSER_NOT_SUPPORT));
  return (
    <Router history={history}>
      {isMaintenance && <Route path={PUBLIC_ROUTE.MAINTENANCE} render={() => { window.location.href = "maintenance.html" }} />}
      {isMaintenance && <Redirect
          push={true}
          to={{
            pathname: PUBLIC_ROUTE.MAINTENANCE,
          }}
      />}
      {checkBrowserNotSupport && <Route path={PUBLIC_ROUTE.BROWSER_NOT_SUPPORTED} render={() => { window.location.href = "browserNotSupported.html" }} />}
      {checkBrowserNotSupport && <Redirect
          push={true}
          to={{
            pathname: PUBLIC_ROUTE.BROWSER_NOT_SUPPORTED,
          }}
      />}

      <Switch>
        {publicRoutes.map((route, index) => (
          <Route key={index} path={route.path} exact={route.exact}>
            <route.component />
          </Route>
        ))}
        <PrivateRoute path="/main">
          <Main />
        </PrivateRoute>
        <Redirect
          to={{
            pathname: localIsLogin ? '/main' : '/signin',
          }}
        />
      </Switch>
      <AppIdleTimer/>
    </Router>
  );
}
